export default __webpack_public_path__ + "static/media/alexanderjaccuzi.b17efd8a.jpg";